import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// interface UserState {
//     user: any | null;
//     wallet: { blish_crowns: number; locked_crowns: number } | null;
//     isAuthenticated: boolean;
//     accessToken: string | null;
//     refreshToken: string | null;

//     // Actions
//     setAuth: (user: any, access: string, refresh: string) => void;
//     updateWallet: (balances: { blish_crowns: number; locked_crowns: number }) => void;
//     logout: () => void;
// }

/**
 * Zustand store hook persisted to localStorage under the key "blish-storage".
 *
 * @typedef {Object} StoreState
 * @property {?Object} user - Authenticated user object, or null when not logged in.
 * @property {?Object} wallet - Wallet information, or null when not available.
 * @property {boolean} isAuthenticated - Whether the user is authenticated.
 * @property {?string} accessToken - Access token for authenticated requests, or null.
 * @property {?string} refreshToken - Refresh token for renewing authentication, or null.
 * @property {function(Object, string, string): void} setAuth - Set the authenticated user, access token, and refresh token.
 * @property {function(Object): void} updateWallet - Update the wallet state.
 * @property {function(): void} logout - Clear authentication and wallet state.
 *
 * @type {import('zustand').UseStore<StoreState>}
 */
export const useStore = create()(
    persist(
        (set) => ({
            user: null,
            wallet: null,
            isAuthenticated: false,
            accessToken: null,
            refreshToken: null,

            setAuth: (user, accessToken, refreshToken) =>
                set({ user, accessToken, refreshToken, isAuthenticated: true }),

            updateWallet: (wallet) => set({ wallet }),

            logout: () => set({
                user: null,
                wallet: null,
                accessToken: null,
                refreshToken: null,
                isAuthenticated: false
            }),
        }),
        { name: 'blish-storage' } // Persists to localStorage
    )
);